<dx-popup
  [showTitle]="true"
  title="Erreurs de paramétrage"
  [(visible)]="displayDialog"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()"
  >
  <div>
    Présence de doublons : vos modifications n'ont pas été enregistrées.
    Merci de vérifier votre paramétrage
  </div>
  <dx-data-grid
    [dataSource]="errors"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showRowLines]="true"
    [showBorders]="true"
  >
    <dxi-column dataField="regroupementLibelle" caption="Règle de regroupement"></dxi-column>
    <dxi-column dataField="plat" caption="Plat"></dxi-column>
    <dxi-column dataField="pointDeLivraison" caption="Point de livraison"></dxi-column>
    <dxi-column dataField="prestations" caption="Convive(s)"></dxi-column>

    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} erreur(s)">
    </dxo-pager>
  </dx-data-grid>

</dx-popup>
